import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './printlogs.action';
import { Printlogs } from './printlogs.model';

export interface PrintlogsRecordsState {
    listData: Printlogs[];
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: PrintlogsRecordsState = {
    listData: [],
    loading: false,
    error: null,
    total: 0
};


export const PrintlogsRecordReducer = createReducer(

    initialState,

    // FETCH ALL RECORDS
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // RESET DATA
    on(resetState, () => initialState)
    
);